const FLOW_TOKEN_PREFIX = 'flow_token='


/**
 * Separates the one-time flow token from the rest of a URL fragment.
 *
 * The token is read exactly as it appears, with no decoding, because it
 * arrives unencoded. Everything else in the fragment is left as it was.
 *
 * An empty token is no token.
 *
 * @param {String} hash - a URL fragment, with or without its leading `#`
 *
 * @returns {Object} with the shape { flowToken, hash }: the token, or `null`
 *   when the fragment carries none, and the fragment without it, which keeps
 *   its leading `#` only when something remains
 */
export default function removeFlowToken(hash) {
  const parts = hash.replace(/^#/, '').split('&')
  const tokenPart = parts.find((part) => part.startsWith(FLOW_TOKEN_PREFIX))
  const flowToken = tokenPart?.slice(FLOW_TOKEN_PREFIX.length) || null

  const remainingParts = parts.filter((part) => part && !part.startsWith(FLOW_TOKEN_PREFIX))
  const remainingHash = ( remainingParts.length ) ? `#${ remainingParts.join('&') }` : ''

  return {
    flowToken,
    hash: remainingHash,
  }
}
